import { h } from 'preact';
import { Route, Router } from 'preact-router';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import Login from '../routes/login';

const App = () => (
  <div id="app">
    <Router>
      <Route path="/" component={Home} />
      <Route path="/:widgetIds" component={Home} />
      <Route path="/login/:pacUuid" component={Login} />
    </Router>
  </div>
);

export default App;
